// extracted by mini-css-extract-plugin
module.exports = {"container":"ResponsivePageBody_container__2kEZa"};